import React from 'react'

import { useLocation } from 'react-router-dom'
import { AsistenciaContextProvider } from '../../../../context/AsistenciaContext'
import { TechnicalAssistanceProvider } from '../../../../context/TechnicalAssistanceContext'
import AsistenciaTecnicaFormView from './AsistenciaTecnica'

const FormAsistenciaTecnicaView = () => {
  const location = useLocation()
  return (
    <AsistenciaContextProvider>
      <TechnicalAssistanceProvider>
        <AsistenciaTecnicaFormView idForm={location.state} />
      </TechnicalAssistanceProvider>
    </AsistenciaContextProvider>
  )
}

export default FormAsistenciaTecnicaView
